import { TemplatePlaceholder } from './templatePlaceholder.js';
import { SlottedTemplate } from './slottedTemplate.js';
import { JsonKeyPlaceholder } from './jsonKeyPlaceholder.js';
import { JsonArrayPlaceholder } from './jsonArrayPlaceholder.js';
import { JsonArraySkipPlaceholder } from './jsonArraySkipPlaceholder.js';
import { ReplacementMapping } from './replacementMapping.js';

export class PreprocessedTemplate {
    originalContent: string = '';
    actualTemplateName: string | null = null;
    placeholders: TemplatePlaceholder[] = [];
    slottedTemplates: SlottedTemplate[] = [];
    jsonKeyPlaceholders: JsonKeyPlaceholder[] = [];
    jsonSkipPlaceholders: JsonKeyPlaceholder[] = [];
    jsonArrayPlaceholders: JsonArrayPlaceholder[] = [];
    jsonArraySkipPlaceholders: JsonArraySkipPlaceholder[] = [];
    replacementMappings: ReplacementMapping[] = [];

    constructor() {}

    get hasPlaceholders(): boolean {
        return this.placeholders.length > 0;
    }

    get hasSlottedTemplates(): boolean {
        return this.slottedTemplates.length > 0;
    }

    get hasReplacementMappings(): boolean {
        return this.replacementMappings.length > 0;
    }

    get requiresProcessing(): boolean {
        return this.hasPlaceholders || this.hasSlottedTemplates || this.hasReplacementMappings;
    }
}
